<template>
  <XButton class="login-btn" type="primary" @click="goToLogin">
    {{ $t('deng-lu-zhu-ce') }}
  </XButton>
</template>

<script setup lang="ts">
// https://www.figma.com/design/1j2j0YcPd4M2GRrhAqEPot/%E6%9C%89%E8%A8%80%E6%9C%8D%E5%8A%A1%E5%B9%B3%E5%8F%B0%E9%9C%80%E6%B1%82?node-id=9298-8327&t=jgwIVzStbopgMIz1-0
import XButton from '~/design/atom/button.vue';
import { goLogin } from '~/utils/permission';
import { TRACK_EVENT } from '~/utils/track.ts';

const goToLogin = () => {
  trackEvent(TRACK_EVENT.CLICK_GOTO_LOGIN);

  goLogin({ redirect: encodeURIComponent(encodeURIComponent(location.href)) });
};
</script>

<style lang="scss" scoped>
.login-btn {
  margin-left: 12px;
  font-size: 16px;
  line-height: 36px;
  height: 36px;
  font-weight: 400;
  min-width: 100px;
  border-radius: 8px;
  padding: 0 24px;
  background-color: var(--purple-6) !important;
  &:hover,
  &:active {
    background-color: var(--purple-7) !important;
  }
}
</style>
